import axios from '../axios';

const BASE_URL = '/user/settings/';
const DELETE_ACCOUNT_URL = '/user/delete-account/';

const UserSettingsAPI = {
  getSettings: async () => {
    try {
      const response = await axios.get(BASE_URL);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSettings: async (data) => {
    try {
      const response = await axios.patch(BASE_URL, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteAccount: async () => {
    try {
      const response = await axios.delete(DELETE_ACCOUNT_URL);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default UserSettingsAPI;
